export interface GpsPosition {
  lat: number;
  lon: number;
  accuracy: number;
  speed: number | null;
  heading: number | null;
  timestamp: number;
}

export interface GpsError {
  type: 'permissionDenied' | 'unavailable' | 'timeout';
  message: string;
}

export interface GpsOptions {
  onPosition: (position: GpsPosition) => void;
  onError: (error: GpsError) => void;
  enableHighAccuracy?: boolean;
  maximumAge?: number;
  timeout?: number;
}

export function startWatching(options: GpsOptions): { stop: () => void } {
  const {
    onPosition,
    onError,
    enableHighAccuracy = true,
    maximumAge = 0,
    timeout = 5000,
  } = options;

  if (!navigator.geolocation) {
    onError({
      type: 'unavailable',
      message: 'Geolocation API not available'
    });
    return { stop: () => {} };
  }

  const watchId = navigator.geolocation.watchPosition(
    (position) => {
      onPosition({
        lat: position.coords.latitude,
        lon: position.coords.longitude,
        accuracy: position.coords.accuracy,
        speed: position.coords.speed,
        heading: position.coords.heading,
        timestamp: position.timestamp,
      });
    },
    (error) => {
      let errorType: GpsError['type'] = 'unavailable';
      if (error.code === error.PERMISSION_DENIED) {
        errorType = 'permissionDenied';
      } else if (error.code === error.TIMEOUT) {
        errorType = 'timeout';
      }

      onError({
        type: errorType,
        message: error.message
      });
    },
    {
      enableHighAccuracy,
      maximumAge,
      timeout,
    }
  );

  return {
    stop: () => {
      navigator.geolocation.clearWatch(watchId);
    }
  };
}